enum ScopeWorkflowFormType {
  VIEW,
  EDIT,
  ADD
}

export default ScopeWorkflowFormType